<template>
  <div class="sidebar" data-color="white" data-active-color="primary">
    <div class="logo">
      <a href="#" class="simple-text logo-mini"></a>
      <a href="#" class="simple-text logo-normal">Enroll Admin</a>
    </div>
    <div class="sidebar-wrapper">
      <ul class="nav">
        <li v-for="item in routes" :key="item.id">
          <router-link
            v-if="!item.children.length"
            :to="item.path"
            tag="li"
            exact-active-class="active"
          >
            <a href="#">
              <i :class="item.icon"></i>
              <p>{{ item.label }}</p>
            </a>
          </router-link>
          <template v-else>
            <a
              data-toggle="collapse"
              href="javascript:;"
              v-b-toggle="`collapse-${item.id}`"
            >
              <i :class="item.icon"></i>
              <p>
                {{ item.label }}
                <b class="caret"></b>
              </p>
            </a>
            <b-collapse :id="`collapse-${item.id}`" :visible="isVisible(item)">
              <ul class="nav">
                <router-link
                  v-for="child in item.children"
                  :key="child.id"
                  :to="child.path"
                  tag="li"
                  exact-active-class="active"
                  class="collapse-menu-item"
                >
                  <a href="#">
                    <i :class="child.icon"></i>
                    <p>{{ child.label }}</p>
                  </a>
                </router-link>
              </ul>
            </b-collapse>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      routes: [
        {
          id: "dashboard",
          label: "Dashboard",
          path: "/dashboard",
          icon: "fas fa-tachometer-alt",
          children: []
        },
        {
          id: "head-hunting",
          label: "Head Hunting",
          path: "/head-hunting",
          icon: "fas fa-user-secret",
          children: []
        },
        {
          id: "offers-group",
          label: "Offers",
          path: "",
          icon: "fas fa-briefcase",
          children: [
            {
              id: "offers",
              label: "Offer Listings",
              path: "/offers",
              icon: "fas fa-list"
            },
            {
              id: "offer-attributes",
              label: "Offer Attributes",
              path: "/offer-attributes",
              icon: "fas fa-tags"
            },
            {
              id: "noc-mappings",
              label: "NOC Mappings",
              path: "/noc-mappings",
              icon: "fas fa-sitemap"
            }
          ]
        },
        {
          id: "companies",
          label: "Companies",
          path: "",
          icon: "fas fa-building",
          children: [
            {
              id: "view-companies",
              label: "View Companies",
              path: "/companies",
              icon: "fas fa-list",
              children: []
            },
            {
              id: "company-join-requests",
              label: "Company Join Requests",
              path: "/companies/pending",
              icon: "fas fa-user-plus",
              children: []
            },
            {
              id: "feed-companies",
              label: "Feed Companies",
              path: "/companies/feed",
              icon: "fas fa-rss",
              children: []
            }
          ]
        },
        {
          id: "prices",
          label: "Prices",
          path: "/prices",
          icon: "fas fa-dollar-sign",
          children: []
        },
        {
          id: "feeds-group",
          label: "Feeds",
          path: "",
          icon: "fas fa-exchange-alt",
          children: [
            {
              id: "feed-in",
              label: "Feed In",
              path: "/feed-in",
              icon: "fas fa-download"
            },
            {
              id: "feed-out",
              label: "Feed Out",
              path: "/feed-out",
              icon: "fas fa-upload"
            },
            {
              id: "diffusions",
              label: "Diffusions",
              path: "/diffusions",
              icon: "fas fa-bullhorn"
            },
            {
              id: "indeed-logs",
              label: "Indeed Logs",
              path: "/indeed/logs",
              icon: "fas fa-scroll"
            },
            {
              id: "indeed-postings",
              label: "Indeed Postings",
              path: "/indeed/postings",
              icon: "fas fa-briefcase"
            }
          ]
        },
        {
          id: "newsletter-email-templates",
          label: "Newsletters",
          path: "/emailing/newsletter-email-templates",
          icon: "fas fa-envelope",
          children: []
        },
        {
          id: "jobboard-specs",
          label: "Jobboard Specs",
          path: "/jobboard-spec",
          icon: "fas fa-globe",
          children: []
        },
        {
          id: "users-group",
          label: "Users",
          path: "",
          icon: "fas fa-users",
          children: [
            {
              id: "employers",
              label: "Employers",
              path: "/users/employers",
              icon: "fas fa-user-tie"
            },
            {
              id: "candidates",
              label: "Candidates",
              path: "/users/candidates",
              icon: "fas fa-user"
            }
          ]
        }

        /*{
          label: "Analytics",
          path: "/analytics",
          icon: ""
        },
        {
          label: "Member Join Requests",
          path: "/member/join-request",
          icon: ""
        },
        {
          label: "Employer Groups",
          path: "/employer-groups",
          icon: ""
        },
        {
          label: "Offers",
          path: "/offers",
          icon: ""
        },
        {
          label: "Feed Logs",
          path: "/feed-logs",
          icon: ""
        },
        {
          label: "Stripe",
          path: "/stripe/unsubscribed-groups",
          icon: ""
        }*/
      ]
    };
  },
  methods: {
    isVisible(item) {
      return item.children.some(child =>
        this.$route.path.startsWith(child.path)
      );
    }
  }
};
</script>
